import { combineReducers } from "redux";

import App from "./app/reducer";
// Front
import Layout from "./layouts/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import Calendar from "./calendar/reducer";
import Mail from "./mail/reducer";
import Notification from "./notification/reducer";

// Address
import Province from "./province/reducer";
import City from "./city/reducer";
import District from "./district/reducer";
import Village from "./village/reducer";
import Address from "./address/reducer";
import Marital from "./marital/reducer";
import MaritalTax from "./maritalTax/reducer";

//Bank
import Bank from "./bank/reducer";
import BankData from "./bankData/reducer";

import Identity from "./identity/reducer";
import IdentityType from "./identityType/reducer";

// Company
import Client from "./client/reducer";
import Company from "./company/reducer";
import Brand from "./brand/reducer";
import Branch from "./branch/reducer";

//Files
import File from "./file/reducer";
import Folder from "./folder/reducer";

// hr
import Employee from "./employee/reducer";
import EmployeeFace from "./employeeFace/reducer";
import Department from "./department/reducer";
import Position from "./position/reducer";
import PermissionCategory from "./permissionCategory/reducer";

import Report from "./report/reducer";

import EmployeeContract from "./employeeContract/reducer";
import EmployeeContractType from "./employeeContractType/reducer";
import EmployeeLocation from "./employeeLocation/reducer";
import EmployeeWarning from "./employeeWarning/reducer";
import PositionChange from "./positionChange/reducer";
import Termination from "./termination/reducer";
import Payrate from "./payrate/reducer";
import Religion from "./religion/reducer";
import Education from "./education/reducer";
import EducationLevel from "./educationLevel/reducer";
import FamilyContactType from "./familyContactType/reducer";
import FamilyContact from "./familyContact/reducer";

import Payroll from "./payroll/reducer";
import AttEvent from "./attEvent/reducer";
import AttSchedule from "./attSchedule/reducer";
import AttScheduleDetail from "./attScheduleDetail/reducer";
import PayrollComponent from "./payrollComponent/reducer";
import PayrollComponentDetail from "./payrollComponentDetail/reducer";
import AccSetting from "./accSetting/reducer";
import WorkGroup from "./workGroup/reducer";
import WorkGroupDetail from "./workGroupDetail/reducer";
import Attendance from "./attendance/reducer";
import EmployeeTax from "./employeeTax/reducer";

import Performance from "./performance/reducer";
import PerformanceAppraisal from "./performanceAppraisal/reducer";
import PerformanceAppraisalDetail from "./performanceAppraisalDetail/reducer";
import PerformancePredicate from "./performancePredicate/reducer";
import PerformanceScore from "./performanceScore/reducer";
import PerformanceScoreDetail from "./performanceScoreDetail/reducer";
import EmployeeAssessment from "./employeeAssessment/reducer";
import EmployeeAssessmentDetail from "./employeeAssessmentDetail/reducer";

import LoanTerm from "./loanTerm/reducer";
import Loan from "./loan/reducer";
import AccTrans from "./accTrans/reducer";
import AccReleaseTrans from "./accReleaseTrans/reducer";

import ReimbursementType from "./reimbursementType/reducer";
import Reimbursement from "./reimbursement/reducer";
import PayrollSalary from "./payrollSalary/reducer";

import Task from "./task/reducer";
import TaskDetail from "./taskDetail/reducer";
import TaskList from "./taskList/reducer";
import TaskListDetail from "./taskListDetail/reducer";
import TaskCategory from "./taskCategory/reducer";

//Inventory
import Product from "./product/reducer";
import ProductCategory from "./productCategory/reducer";
import ProductBlock from "./productBlock/reducer";
import ProductOption from "./productOption/reducer";
import ProductOptionDetail from "./productOptionDetail/reducer";
import ProductVarian from "./productVarian/reducer";
import ProductTag from "./productTag/reducer";
import ProductHandover from "./productHandover/reducer";
import ProductComplain from "./productComplain/reducer";
import Campaign from "./campaign/reducer";
import ProductInventory from "./productInventory/reducer";
import ProductInventoryDetail from "./productInventoryDetail/reducer";
import ProductType from "./productTypes/reducer";

import CreditOption from "./creditOption/reducer";
import CreditOptionDetail from "./creditOptionDetail/reducer";

//Inventory
import Asset from "./asset/reducer";
import AssetTag from "./assetTag/reducer";
import AssetCategory from "./assetCategory/reducer";
import AssetInspection from "./assetInspection/reducer";
import AssetInspectionCategory from "./assetInspectionCategory/reducer";
import AssetClass from "./assetClass/reducer";
import LegalityAsset from "./legalityAsset/reducer";
import ProductInventoryBranch from "./productInventoryBranch/reducer";
import Uom from "./uom/reducer";
import Disposal from "./disposal/reducer";
import Depreciation from "./depreciation/reducer";
import FollowupList from "./followupList/reducer";
import Nominatif from "./nominatif/reducer";

import ShipmentMethod from "./shipmentMethod/reducer";
import ShipmentCarrier from "./shipmentCarrier/reducer";
import PaymentMethod from "./paymentMethod/reducer";
import PaymentTerm from "./paymentTerm/reducer";
import TransactionTax from "./transactionTax/reducer";

import AccAccount from "./accAccount/reducer";
import AccCategory from "./accCategory/reducer";
import AccTag from "./accTag/reducer";
import AccAccountClose from "./accAccountClose/reducer";

//Purchase
import Purchase from "./purchase/reducer";
import PurchaseDetail from "./purchaseDetail/reducer";
import PurchaseHistory from "./purchaseHistory/reducer";
import Legal from "./legal/reducer";
import LegalMaster from "./legalMaster/reducer";
import LegalStatus from "./legalStatus/reducer";

//Sales
import Sales from "./sales/reducer";
import SalesPublic from "./salesPublic/reducer";
import SalesBook from "./salesBook/reducer";
import SalesPromo from "./salesPromo/reducer";
import SalesDetail from "./salesDetail/reducer";
import CampaignDetail from "./campaignDetail/reducer";
import Marketing from "./marketing/reducer";
import SalesHistory from "./salesHistory/reducer";
import SalesWarranty from "./salesWarranty/reducer";
import SalesPayment from "./salesPayment/reducer";
import SalesChannel from "./salesChannel/reducer";
import SalesType from "./salesType/reducer";
import SalesTarget from "./salesTarget/reducer";
import ApplicantDocument from "./applicantDocument/reducer";
import LegalityDocument from "./legalityDocument/reducer";
import HandoverList from "./handoverList/reducer";
import HandoverListEngineering from "./handoverListEngineering/reducer";

//CRM
import Contact from "./contact/reducer";
import Market from "./market/reducer";
import Deal from "./deal/reducer";
import DealTag from "./dealTag/reducer";
import DealStatus from "./dealStatus/reducer";

//Transfer
import Transfer from "./transfer/reducer";
import TransferDetail from "./transferDetail/reducer";
import TransferHistory from "./transferHistory/reducer";

//Customer
import Customer from "./customer/reducer";
import CustomerGroup from "./customerGroup/reducer";
import Applicant from "./applicant/reducer";
import BankBranch from "./bankBranch/reducer";

// Dashboard CRM
import Vendor from "./vendor/reducer";

// Dashboard CRM
import Dashboard from "./dashboard/reducer";
import Role from "./role/reducer";
import RoleList from "./roleList/reducer";

//Users
import Users from "./users/reducer";
import StorageFile from "./storageFiles/reducer";
import StorageFolder from "./storageFolder/reducer";
import StorageMove from "./storageMove/reducer";
import StorageRename from "./storageRename/reducer";
import Service from "./service/reducer";
import CampaignPage from "./campaignPage/reducer";
import PrintTemplate from "./printTemplate/reducer";

import Ticket from "./ticket/reducer";
import TicketCategory from "./ticketCategory/reducer";

//Survey
import Survey from "./survey/reducer";
import SurveyScore from "./surveyScore/reducer";
import SurveyTemplate from "./surveyTemplate/reducer";
import SurveyTemplateDetail from "./surveyTemplateDetail/reducer";

//Agency
import Agent from "./agent/reducer";
import Agency from "./agency/reducer";

//KONTENT
import Content from "./content/reducer";
import ContentCategory from "./contentCategory/reducer";
import Catalog from "./catalog/reducer";

//civilmaterial
import CivilAccountCategory from "./civilAccountCategory/reducer";
import CivilAccount from "./civilAccount/reducer";
import CivilBudget from "./civilBudget/reducer";
import CivilProgression from "./civilProgression/reducer";
import CivilOpname from "./civilOpname/reducer";
import CivilBudgetSchedule from "./civilBudgetSchedule/reducer";
import CivilBudgetDetail from "./civilBudgetDetail/reducer";
import CivilBudgetControl from "./civilBudgetControl/reducer";
import CivilBudgetControlMaterial from "./civilBudgetControlMaterial/reducer";
import CivilBudgetMaterial from "./civilBudgetMaterial/reducer";
import CivilContract from "./civilContract/reducer";

import Budget from "./budget/reducer";

//perijinan
import LegalSiteplan from "./legalSiteplan/reducer";
import LegalBridge from "./legalBridge/reducer";
import LegalPeil from "./legalPeil/reducer";
import LegalRumija from "./legalRumija/reducer";
import LegalPermission from "./legalPermission/reducer";
import LegalFraction from "./legalFraction/reducer";
import Transaction from "./transaction/reducer";
import Admin from "./admin/reducer";

const rootReducer = combineReducers({
  App,
  Layout,
  Login,
  Account,
  Notification,
  ForgetPassword,
  Profile,
  Dashboard,
  Client,
  Company,
  Address,
  Province,
  City,
  District,
  Village,
  Bank,
  BankData,
  Identity,
  IdentityType,
  Marital,
  MaritalTax,
  Religion,
  Education,
  EducationLevel,
  FamilyContact,
  FamilyContactType,
  Calendar,
  Mail,
  Users,

  Report,

  Folder,
  File,

  Brand,
  Branch,

  Employee,
  Department,
  Position,
  PermissionCategory,
  EmployeeFace,
  EmployeeContract,
  EmployeeContractType,
  EmployeeLocation,
  EmployeeWarning,
  PositionChange,
  Payrate,
  Termination,

  Payroll,
  PayrollSalary,
  Attendance,
  AttEvent,
  WorkGroup,
  WorkGroupDetail,
  PayrollComponent,
  PayrollComponentDetail,
  AccSetting,
  AttSchedule,
  AttScheduleDetail,
  EmployeeTax,
  LoanTerm,
  Loan,
  AccTrans,
  AccReleaseTrans,
  ReimbursementType,
  Reimbursement,

  Performance,
  PerformanceAppraisal,
  PerformanceAppraisalDetail,
  PerformancePredicate,
  PerformanceScore,
  PerformanceScoreDetail,
  EmployeeAssessment,
  EmployeeAssessmentDetail,

  Task,
  TaskDetail,
  TaskList,
  TaskListDetail,
  Ticket,
  TaskCategory,

  Product,
  ProductCategory,
  ProductBlock,
  ProductOption,
  ProductOptionDetail,
  ProductVarian,
  ProductTag,
  Campaign,
  ProductInventory,
  ProductInventoryDetail,
  ProductType,
  ProductHandover,
  ProductComplain,

  CreditOption,
  CreditOptionDetail,

  Asset,
  AssetTag,
  AssetCategory,
  AssetInspection,
  AssetInspectionCategory,
  AssetClass,
  LegalityAsset,
  ProductInventoryBranch,
  Uom,
  Disposal,
  Depreciation,
  FollowupList,
  Nominatif,

  Contact,
  Market,
  Deal,
  DealTag,
  DealStatus,

  PaymentMethod,
  PaymentTerm,
  ShipmentCarrier,
  ShipmentMethod,
  AccAccount,
  AccCategory,
  AccTag,
  AccAccountClose,
  TransactionTax,

  Purchase,
  PurchaseDetail,
  PurchaseHistory,
  Legal,
  LegalMaster,
  LegalStatus,

  Sales,
  SalesPublic,
  SalesBook,
  SalesPromo,
  SalesDetail,
  Marketing,
  SalesHistory,
  SalesWarranty,
  SalesPayment,
  CampaignDetail,
  SalesChannel,
  SalesType,
  SalesTarget,
  ApplicantDocument,
  LegalityDocument,
  HandoverList,
  HandoverListEngineering,

  Transfer,
  TransferDetail,
  TransferHistory,

  Customer,
  CustomerGroup,
  Applicant,
  BankBranch,
  Vendor,
  Role,
  RoleList,
  StorageFile,
  StorageFolder,
  StorageMove,
  StorageRename,
  CampaignPage,
  Service,
  TicketCategory,
  PrintTemplate,

  Survey,
  SurveyScore,
  SurveyTemplate,
  SurveyTemplateDetail,

  Agent,
  Agency,

  Content,
  ContentCategory,
  Catalog,

  CivilAccountCategory,
  CivilAccount,
  CivilBudget,
  CivilProgression,
  CivilOpname,
  CivilBudgetSchedule,
  CivilBudgetControl,
  CivilBudgetControlMaterial,
  CivilBudgetDetail,
  CivilBudgetMaterial,
  CivilContract,
  Budget,

  LegalSiteplan,
  LegalBridge,
  LegalPeil,
  LegalRumija,
  LegalPermission,
  LegalFraction,
  Transaction,
  Admin
});

export default rootReducer;
